module.exports = __webpack_public_path__ + "img/top_hk.6def90a0.png";